import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";
import {rxUpdateTransactions} from "./transactionsSlice";
import {rxUpdateMileageLogs} from "./mileageLogsSlice";
import {rxUpdatePortfolioTransactions} from "./portfolioSlice";

const accountsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.position - b.position
});

const initialState = {
  accounts: accountsAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null
  }
};

export const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.account = action.payload.account;
    },

    hideEditor: state => {
      state.editor.show = false;
    },

    submitEditor: (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload);
    },

    updateAccounts: (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload);
    },

    reorderAccounts: (state, action) => {
      let position = 1;

      accountsAdapter.setMany(state.accounts, action.payload.map(a => ({...a, position: position++})));
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload.accounts);
    });

    builder.addCase(rxUpdateTransactions, (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload.a || []);
    });

    builder.addCase(rxUpdateMileageLogs, (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload.a || []);
    });

    builder.addCase(rxUpdatePortfolioTransactions, (state, action) => {
      accountsAdapter.setMany(state.accounts, action.payload.a || []);
    });
  }
});

export const {
  showEditor: rxShowAccountEditor,
  hideEditor: rxHideAccountEditor,
  submitEditor: rxSubmitAccountEditor,
  updateAccounts: rxUpdateAccounts,
  reorderAccounts: rxReorderAccounts
} = accountsSlice.actions;

export const {selectAll: selectAllAccounts} = accountsAdapter.getSelectors(state => state.accounts.accounts);

export const editorConfigSelector = state => state.accounts.editor;

export default accountsSlice.reducer;
